// AdminApp
import styles from './sass/admin.scss';
import React from 'react';
import axios from 'axios';

import DomImage from './components/DomImage'
import AdminLogin from './components/admin/AdminLogin'
import AdminChatsList from './components/admin/AdminChatsList'

export default class AdminApp extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
            is_auth: null, error: '',
            admin_url : `${this.props.serverUrl}/admin`
        }
	}

	componentWillMount() {
        // Hit a first endpoint to determine whether or not we're logged in
        axios.get(
					this.state.admin_url + '/sessions'+'?'+(new Date().getTime()),
					{ withCredentials: true }
					)
        .then(response => {
        	// Response is 200, we're logged in
            setTimeout(() => { this.setState({ is_auth: true }); }, 1000);
        })
        .catch(err => {
            // Response is 4xx, we're NOT logged in
        	setTimeout(() => { this.setState({ is_auth: false }); }, 1000);
        });
	}

	submitLogin(password) {
		if (!password) {
			return false;
		}

		axios.post(
            this.state.admin_url + '/login?' + (new Date().getTime()),
            { password },
						{ withCredentials: true })
        .then(response => {
            this.setState({ is_auth: null });
            setTimeout(() => { this.setState({ is_auth: true }); }, 1000);
        })
        .catch(err => {
          this.setState({ is_auth: false, error: err + '' })
        });
	}

	render() {

		return (
			<div>
				<div className='administration'>
					<div className='heading'>
						<DomImage src={require('./img/pm-icon.png')} className='pmlogo' />
						<h1>Live Chats administration</h1>
						<div className='clear'></div>
					</div>
					{
						(() => {
							if (this.state.is_auth === null){
								return <DomImage src="/img/loader.gif" className='loader' />
							}
							else if (this.state.is_auth === true){
								return <AdminChatsList serverUrl={this.props.serverUrl} />
							}
							else if (this.state.is_auth === false){
								return <AdminLogin submitLogin={this.submitLogin.bind(this)} error={this.state.error} />
							}
						})()
					}
				</div>
				<p className='footer'>
					© PathMotion {new Date().getFullYear()}
				</p>
			</div>
		);
	}
};



// WEBPACK FOOTER //
// ./src/AdminApp.jsx